import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import { getItemFromPersistentStore } from '../../../../common/utils/Persist';
import { getCookieValue, getQueryParams } from '../../../../common/utils/functions';
import ROUTE_CONSTANTS from '../RouteConstants';
import AppHome from '../AppHome';

const ProtectedRouteV2 = (props) => {
  const { path, isMwebOptimised } = props;
  
  const { isAuthenticated, externalParams } = useMemo(() => {
    const isLoggedIn = getItemFromPersistentStore('isLoggedIn', false) || getCookieValue('isLoggedIn') === 'true';
    return {
      isAuthenticated: isLoggedIn === true,
      externalParams: getQueryParams(window.location.href)
    };
  }, []);

  if (!isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: ROUTE_CONSTANTS.LOGIN,
          state: { externalParams, isMwebOptimised }
        }}
      />
    );
  }
  
  return <AppHome {...props} path={path} />;
};

export default withRouter(ProtectedRouteV2);
